import { httpApi } from '@api/http.api.ts';
import type { VesselCrewMemberResponse } from '@routes/sidebar/admin-center/___shared___/dashboards/types.ts';
import type { CommonTableRequest } from '@routes/sidebar/admin-center/___shared___/types.ts';

export type VesselCrewMemberRequest = CommonTableRequest;

export interface SelectedVesselCrewMember {
    userId: number;
    userName: string;
}

export interface PostApiFetchVesselCrewMemberParams {
    tenantAlias: string;
    crewUserId: number;
    payload: VesselCrewMemberRequest;
}

const getVesselCrewMemberBaseUrl = (tenantAlias: string, crewUserId: number) =>
    `admin-center/tenants/${tenantAlias}/statistics/crew/${crewUserId}`;

export const postApiFetchVesselCrewMember = ({
    tenantAlias,
    crewUserId,
    payload,
}: PostApiFetchVesselCrewMemberParams): Promise<VesselCrewMemberResponse> =>
    httpApi
        .post<VesselCrewMemberResponse>(`${getVesselCrewMemberBaseUrl(tenantAlias, crewUserId)}/search`, payload)
        .then(({ data }) => data);
